/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';
import {
  replaceInstallationName as replaceInstallationNameWithConfig,
} from 'shared/helpers/brandingHelper';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "eAtende360" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "eAtende360" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text || typeof text !== 'string') return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return replaceInstallationNameWithConfig(text);

    return text.replace(/eAtende360/g, installationName);
  };

  return {
    replaceInstallationName,
  };
}
